import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppInput, AppRemixIcon } from "@/layout/AppComponents";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import { axiosPath } from "../../../../routing/helpers/router";
import useIsMounted from "../../../components/hooks/useIsMounted";
import AppSubmitButton from "../../../../layout/components/form/AppSubmitButton";
import errorHandler from "@/layout/components/error/ErrorHandler";
import * as currentPageAction from "../../../../store/actions/currentPageAction";

export default function FolderHome({ elementID, onClose }) {
  const { moduleBridgeHex, parentItemHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const itLevel1 = useSelector(
    (state) => state.currentPage?.elementLevels?.level1?.[elementID]
  );
  const [validationSchema] = useState(
    Yup.object().shape({
      title: Yup.string().required("Introduce un nombre"),
    })
  );

  const handleSave = useCallback(
    async (v) =>
      axios
        .post(
          axiosPath(
            `api_r_user_module_documentManager_item_folder_${
              elementID ? "edit" : "add"
            }`
          ),
          {
            moduleBridgeHex,
            parentItemHex,
            itemHex: itLevel1?.hex,
            ...v,
          }
        )
        .then(() => {
          if (isMounted.current) {
            dispatch(currentPageAction.change("options", { loading: true }));
            onClose();
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, parentItemHex, itLevel1]
  );

  return (
    <Formik
      initialValues={{
        title: itLevel1?.title || "",
      }}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values) => handleSave(values)}
    >
      {({ setFieldValue, errors, handleSubmit, values, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <AppInput
            icon={<AppRemixIcon icon="font-color" noVariants />}
            title="Nombre de carpeta"
            value={values.title}
            error={errors.title}
            onChange={(v) => setFieldValue("title", v)}
            isClearable
          />
          <AppSubmitButton
            className="btn btn-xs btn-outline-light btn-block"
            isSubmitting={isSubmitting}
            icon="save-3"
          >
            {elementID ? "Editar" : "Añadir"}
          </AppSubmitButton>
        </form>
      )}
    </Formik>
  );
}
